import Vue from 'vue';
import VueI18nManager from 'vue-i18n-manager';
import store from '@/store';
import router from '@/router';

import { DEFAULT_LOCALE, SUPPORT_LOCALES } from '@/locales/locales.js';
import { ru, ua } from '@/locales/lang';

let translations = { ru, ua };

const proxy = {
  getTranslation: async ({ translationKey }) => {
    try {
      let result = await store.dispatch(`setting/GET_TRANSLATIONS`);
      return { ...translations[translationKey], ...result };
    } catch (e) {
      console.error(e);
      return translations[translationKey];
    }
  }
};

Vue.use(VueI18nManager, {
  store,
  router,
  proxy,
  config: {
    defaultCode: DEFAULT_LOCALE,
    languages: SUPPORT_LOCALES,
    // translations
    translations: proxy
  }
});
